// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c96ca4b5","85":"2ea28260","152":"046ba23e","300":"63463484","367":"ade7d5f0","411":"a87625db","432":"344f3994","453":"80277a13","497":"50bbf249","752":"46ac45a9","777":"65980cdf","952":"dfb2b86a"}[chunkId] + ".chunk.js";
};